<template>
    <div>
    <h1 class="font-semibold text-xl">Top States</h1>
    <TopRegions />
  </div>
</template>

<script>
import TopRegions from '../component/includes/one_quarter/TopRegions.vue';

export default {
  name: 'TopStates',
  components: {
    TopRegions,
  },
};
</script>

<style scoped>

</style>
